import { render, staticRenderFns } from "./test_cxkq2.vue?vue&type=template&id=71ece9ca&scoped=true&"
import script from "./test_cxkq2.vue?vue&type=script&lang=js&"
export * from "./test_cxkq2.vue?vue&type=script&lang=js&"
import style0 from "./test_cxkq2.vue?vue&type=style&index=0&id=71ece9ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ece9ca",
  null
  
)

export default component.exports